/* eslint-disable */
import * as React from 'react';

export default ({ color = '#FFE600' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="358"
    height="201"
    fill="none"
    viewBox="0 0 358 201"
  >
    <path
      fill="#000"
      fillOpacity="0.04"
      fillRule="evenodd"
      d="M303.626 199.248a135 135 0 0 0 6.718-5.546c41.06-36.224 48.803-70.326 47.103-108.33-1.713-38.416-25.575-101.038-83.065-81.779-57.49 19.263-79.174 23.577-131.524 11.769s-102.487.704-127.335 34.803c-26.087 35.803-13.389 77.666 2.848 101.244 12.812 18.604 26.892 34.579 46.3 47.901z"
      clipRule="evenodd"
    ></path>
    <mask
      id="mask0_5231_8366"
      width="358"
      height="200"
      x="0"
      y="0"
      maskUnits="userSpaceOnUse"
      style={{ maskType: "alpha" }}
    >
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M303.626 199.248a135 135 0 0 0 6.718-5.546c41.06-36.224 48.803-70.326 47.103-108.33-1.713-38.416-25.575-101.038-83.065-81.779-57.49 19.263-79.174 23.577-131.524 11.769s-102.487.704-127.335 34.803c-26.087 35.803-13.389 77.666 2.848 101.244 12.812 18.604 26.892 34.579 46.3 47.901z"
        clipRule="evenodd"
      ></path>
    </mask>
    <g stroke="#333" strokeWidth="1.5" mask="url(#mask0_5231_8366)">
      <path d="M235.691 157.939h25.863a4 4 0 0 0 4-4v-20.718m0 0h54.563a4 4 0 0 0 4-4v-29.56a4 4 0 0 1 4-4h53.443m-116.006 37.56v-23.963c0-2.21-1.79-4-4-4h-10.063M101.568 141.984v17.404a4 4 0 0 1-4 4H53.293a4 4 0 0 0-4 4v42.15M81.167 109.409H37.823a4 4 0 0 1-4-4V64.477a4 4 0 0 1 4-4h18.19a4 4 0 0 0 4-4V-3.99M134.991.177V30.42a4 4 0 0 0 4 4h144.11a4 4 0 0 0 4-4V8.828m0-25.592V8.828m0 0h17.987a4 4 0 0 1 4 4V55.65a4 4 0 0 0 4 4h58.358"></path>
    </g>
    <path
      fill={color}
      stroke="#fff"
      strokeWidth="3"
      d="M81.36 66.524h208.212v118.228H81.36z"
    ></path>
    <path
      stroke="#333"
      strokeWidth="1.5"
      d="M80.301 64.737h210.335v120.932H80.301z"
    ></path>
    <path
      fill="#fff"
      stroke="#333"
      strokeWidth="1.5"
      d="M80.301 60.336a7.5 7.5 0 0 1 7.499-7.499h195.375a7.5 7.5 0 0 1 7.499 7.5v4.8H80.301z"
    ></path>
    <path
      fill="#fff"
      d="M63.516 185.892c0 7.411 6.007 13.418 13.417 13.418h217.109c7.41 0 13.417-6.007 13.417-13.418z"
    ></path>
    <path
      fill="#EEE"
      fillRule="evenodd"
      d="M77.486 195.52h216.007c5.982 0 11.043-3.221 12.721-7.653h.592l-.005.299c-.194 5.862-6.078 10.566-13.308 10.566H77.486c-7.352 0-13.313-4.865-13.313-10.865h.592c1.678 4.432 6.739 7.653 12.721 7.653"
      clipRule="evenodd"
      style={{ mixBlendMode: "multiply" }}
    ></path>
    <path
      stroke="#333"
      strokeWidth="1.5"
      d="M63.516 185.892c0 7.411 6.007 13.418 13.417 13.418h217.109c7.41 0 13.417-6.007 13.417-13.418z"
    ></path>
    <path
      stroke="#333"
      strokeWidth="1.5"
      d="M162.389 185.893a4.474 4.474 0 0 0 4.475 4.472h37.246a4.474 4.474 0 0 0 4.476-4.472z"
      clipRule="evenodd"
    ></path>
    <ellipse
      cx="186.091"
      cy="59.569"
      fill="#333"
      rx="1.876"
      ry="1.875"
    ></ellipse>
    <path
      stroke="#333"
      strokeWidth="1.5"
      d="M235.691 157.939h25.863a4 4 0 0 0 4-4v-20.718m0 0v-23.963c0-2.21-1.79-4-4-4h-10.063m14.063 27.963h25.071M101.57 141.984v17.404a4 4 0 0 1-4 4H80.18"
    ></path>
    <path
      fill="#fff"
      stroke="#fff"
      strokeWidth="3"
      d="m164.478 146.953 2.053.059-.569-1.974a5.7 5.7 0 0 1-.216-1.569 5.75 5.75 0 0 1 5.752-5.751 5.74 5.74 0 0 1 2.674.657l2.009 1.054.183-2.262c.608-7.54 6.924-13.47 14.624-13.47 7.687 0 14.597 6.517 14.674 14.533l.018 1.825 1.787-.371a11 11 0 0 1 2.206-.225c5.583 0 10.18 4.227 10.765 9.655l.252 2.338 2.014-1.214a7.13 7.13 0 0 1 10.804 6.112v.006a7.13 7.13 0 0 1-7.133 7.129h-62.129a8.267 8.267 0 1 1 .232-16.532Z"
    ></path>
    <path
      stroke="#333"
      strokeLinejoin="round"
      strokeWidth="1.5"
      d="M235.008 156.356c0 4.767-3.866 8.629-8.633 8.629h-62.129c-5.394 0-9.767-4.373-9.767-9.767s4.373-9.767 9.767-9.767q.14 0 .275.003a7.251 7.251 0 0 1 10.347-8.407c.671-8.314 7.633-14.85 16.12-14.85s16.089 7.158 16.174 16.018a12.4 12.4 0 0 1 2.511-.256c6.357 0 11.591 4.813 12.256 10.995a8.6 8.6 0 0 1 4.446-1.233c4.767 0 8.633 3.862 8.633 8.629z"
    ></path>
    <path
      fill="#fff"
      fillRule="evenodd"
      stroke="#333"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      d="m238.727 81.973.834 3.937a17.2 17.2 0 0 1 5.457 2.624l3.583-1.791c1.875 1.625 3.416 3.583 4.604 5.77l-2.563 3.104a17.5 17.5 0 0 1 1.354 5.916l3.646 1.687a20.3 20.3 0 0 1-1.646 7.186l-4.02-.062a17 17 0 0 1-3.791 4.749l.958 3.896a20.7 20.7 0 0 1-6.645 3.208l-2.458-3.188c-2 .355-4.062.355-6.062 0l-2.458 3.188a20.7 20.7 0 0 1-6.645-3.208l.959-3.896c-1.542-1.333-2.812-2.958-3.792-4.749l-4.02.062c-.979-2.27-1.52-4.707-1.645-7.186l3.645-1.687a16.6 16.6 0 0 1 1.354-5.916l-2.562-3.104c1.166-2.187 2.729-4.124 4.603-5.77l3.604 1.791a16.7 16.7 0 0 1 5.458-2.624l.833-3.937a20.9 20.9 0 0 1 7.374 0zm-3.687 14.394a5.91 5.91 0 0 1 5.916 5.916 5.91 5.91 0 0 1-5.916 5.915 5.91 5.91 0 0 1-5.915-5.915 5.91 5.91 0 0 1 5.915-5.916"
      clipRule="evenodd"
    ></path>
    <path
      fill="#fff"
      stroke="#fff"
      strokeWidth="3"
      d="M59.328 87.678h84.467v51.436c0 .739-.612 1.37-1.406 1.37H60.734c-.794 0-1.406-.631-1.406-1.37z"
    ></path>
    <path
      stroke="#333"
      strokeWidth="1.5"
      d="M57.828 84.085h87.467v54.921c0 1.645-1.301 2.978-2.906 2.978H60.734c-1.605 0-2.906-1.333-2.906-2.978z"
      clipRule="evenodd"
    ></path>
    <path
      fill="#fff"
      fillRule="evenodd"
      stroke="#333"
      strokeWidth="1.5"
      d="M60.735 75.746h81.67c1.605 0 2.907 1.756 2.907 3.923v6.509H57.828v-6.51c0-2.166 1.302-3.922 2.907-3.922Z"
      clipRule="evenodd"
    ></path>
    <ellipse
      cx="65.054"
      cy="80.963"
      fill="#333"
      rx="1.707"
      ry="1.698"
    ></ellipse>
    <ellipse
      cx="72.708"
      cy="80.962"
      fill="#333"
      rx="1.707"
      ry="1.698"
    ></ellipse>
    <ellipse
      cx="80.647"
      cy="80.962"
      fill="#333"
      rx="1.707"
      ry="1.698"
    ></ellipse>
    <path stroke="#333" strokeWidth="1.5" d="M17.061 199.31h336.807"></path>
    <path
      fill="#333"
      d="M308.436 133.78a1.105 1.105 0 0 1 0-1.56l2.897-2.897a1.103 1.103 0 0 1 1.56 0l2.897 2.897a1.103 1.103 0 0 1 0 1.56l-2.897 2.897a1.103 1.103 0 0 1-1.56 0zM235.436 34.78c-.43-.43-.43-1.13 0-1.56l2.897-2.897c.431-.43 1.13-.43 1.56 0l2.897 2.897c.431.43.431 1.13 0 1.56l-2.897 2.897c-.43.43-1.129.43-1.56 0zM30.436 72.78c-.43-.43-.43-1.13 0-1.56l2.897-2.897c.431-.43 1.13-.43 1.56 0l2.897 2.897c.431.43.431 1.13 0 1.56l-2.897 2.897c-.43.43-1.129.43-1.56 0z"
    ></path>
    <path
      stroke="#333"
      strokeLinecap="round"
      strokeWidth="1.5"
      d="M77.522 97.561h11.272M97.238 97.561h32.15M63.614 97.561h5.946M77.522 108.865h24.041M113.312 108.865h16.076M63.614 108.865h5.946M77.522 120.169h11.272M97.238 120.169h11.272M118.115 120.169h19.245M63.614 120.169h5.946M77.522 131.474h32.66M63.614 131.474h5.946M77.522 97.562h11.272M97.238 97.562h32.15M63.614 97.562h5.946M77.522 108.866h24.041M113.312 108.866h16.076M63.614 108.866h5.946M77.522 120.17h11.272M97.238 120.17h11.272M118.115 120.17h19.245M63.614 120.17h5.946M77.522 131.474h32.66M63.614 131.474h5.946"
    ></path>
    <path
      stroke="#333"
      strokeWidth="1.5"
      d="M52.113 149v4M50.113 151h4M273.113 22v4M271.113 24h4M323.113 152v6M320.113 155h6M47.113 41v6M44.113 44h6M318.113 44v4M316.113 46h4M27.054 133.919v-5.773M24.123 131.032l2.93-2.886 2.932 2.886M308.034 101.892v-7.697M304.126 98.043l3.908-3.848 3.908 3.848M96.564 37.932v-4.81M94.121 35.527l2.443-2.405 2.442 2.405"
    ></path>
  </svg>
);

